// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-max-width {
  margin: 0 auto; }
  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .detail-max-width {
      max-width: 960px !important; } }
  @media screen and (min-width: 768px) and (max-width: 991px) {
    .detail-max-width {
      max-width: 720px !important; } }
  @media screen and (min-width: 576px) and (max-width: 767px) {
    .detail-max-width {
      max-width: 540px !important; } }

.task-detail {
  background-color: #1e2930;
  border: 2px solid #34575f;
  border-radius: 10px;
  padding: 0 !important; }
  .task-detail .card {
    --bs-card-bg: transparent !important;
    border: none;
    padding: 20px 20px; }
  .task-detail .card-header {
    align-items: flex-start;
    color: #8edef5;
    margin: 0; }
  .task-detail .card-body {
    color: white;
    padding: 10px; }
    .task-detail .card-body .row {
      border-color: #34575f !important; }
    .task-detail .card-body a {
      color: #ccf2fd;
      background-color: #2f5d6d;
      padding: 4px 10px;
      border-radius: 5px;
      text-decoration: none; }
      .task-detail .card-body a:hover {
        text-decoration: underline; }

.tx-detail-body.card {
  padding: 10px 10px; }

.tx-detail-body .row {
  border-color: #555555 !important;
  font-weight: 500;
  font-size: 12px;
  margin: 5px 0; }
  .tx-detail-body .row .col:first-child {
    font-weight: 500;
    font-size: 12px; }

.detail-header {
  color: white;
  font-weight: 500;
  font-size: 20px;
  border-bottom: 4px solid #2a7e95; }
  .detail-header .address {
    font-weight: 500;
    font-size: 18px; }

.loading-screen {
  min-height: 70vh; }

.proof-detail-scroll {
  max-height: 260px;
  overflow-y: auto;
  font-weight: 400;
  font-size: 12px;
  color: #9dbcc1; }

.verify-proof-btn {
  text-align: center;
  min-width: 60px;
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  color: #ccf2fd;
  background: #2f5d6d;
  border-radius: 5px;
  border: none; }
  .verify-proof-btn:enabled {
    color: #ccf2fd; }
  .verify-proof-btn:hover {
    background: #296e79 !important;
    color: #fefefe; }
  .verify-proof-btn:disabled {
    background: #5c666f;
    color: #202932; }

.debug-logs {
  background: #1e2930; }
`, "",{"version":3,"sources":["webpack://./src/components/TaskDetail/style.scss"],"names":[],"mappings":"AAAA;EAUE,cAAc,EAAA;EATd;IADF;MAEI,2BAA2B,EAAA,EAS9B;EAPC;IAJF;MAKI,2BAA2B,EAAA,EAM9B;EAJC;IAPF;MAQI,2BAA2B,EAAA,EAG9B;;AAED;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB,EAAA;EAJvB;IAMI,oCAAa;IACb,YAAY;IACZ,kBAAkB,EAAA;EARtB;IAYI,uBAAuB;IACvB,cAAc;IACd,SAAS,EAAA;EAdb;IAiBI,YAAY;IACZ,aAAa,EAAA;IAlBjB;MAoBM,gCAAgC,EAAA;IApBtC;MAuBM,cAAc;MACd,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB,EAAA;MA3B3B;QA6BQ,0BAA0B,EAAA;;AAMlC;EAEI,kBAAkB,EAAA;;AAFtB;EAKI,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAA;EARjB;IAUM,gBAAgB;IAChB,eAAe,EAAA;;AAIrB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC,EAAA;EAJlC;IAMI,gBAAgB;IAChB,eAAe,EAAA;;AAGnB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EAEf,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY,EAAA;EATd;IAWI,cAAc,EAAA;EAXlB;IAcI,8BAA8B;IAC9B,cAAc,EAAA;EAflB;IAkBI,mBAAmB;IACnB,cAAc,EAAA;;AAGlB;EACE,mBAAmB,EAAA","sourcesContent":[".detail-max-width {\n  @media screen and (min-width: 992px) and (max-width: 1199px) {\n    max-width: 960px !important;\n  }\n  @media screen and (min-width: 768px) and (max-width: 991px) {\n    max-width: 720px !important;\n  }\n  @media screen and (min-width: 576px) and (max-width: 767px) {\n    max-width: 540px !important;\n  }\n  margin: 0 auto;\n}\n\n.task-detail {\n  background-color: #1e2930;\n  border: 2px solid #34575f;\n  border-radius: 10px;\n  padding: 0 !important;\n  .card {\n    --bs-card-bg: transparent !important;\n    border: none;\n    padding: 20px 20px;\n  }\n\n  .card-header {\n    align-items: flex-start;\n    color: #8edef5;\n    margin: 0;\n  }\n  .card-body {\n    color: white;\n    padding: 10px;\n    .row {\n      border-color: #34575f !important;\n    }\n    a {\n      color: #ccf2fd;\n      background-color: #2f5d6d;\n      padding: 4px 10px;\n      border-radius: 5px;\n      text-decoration: none;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.tx-detail-body {\n  &.card {\n    padding: 10px 10px;\n  }\n  .row {\n    border-color: #555555 !important;\n    font-weight: 500;\n    font-size: 12px;\n    margin: 5px 0;\n    .col:first-child {\n      font-weight: 500;\n      font-size: 12px;\n    }\n  }\n}\n.detail-header {\n  color: white;\n  font-weight: 500;\n  font-size: 20px;\n  border-bottom: 4px solid #2a7e95;\n  .address {\n    font-weight: 500;\n    font-size: 18px;\n  }\n}\n.loading-screen {\n  min-height: 70vh;\n}\n\n.proof-detail-scroll {\n  max-height: 260px;\n  overflow-y: auto;\n  font-weight: 400;\n  font-size: 12px;\n\n  color: #9dbcc1;\n}\n\n.verify-proof-btn {\n  text-align: center;\n  min-width: 60px;\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 12px;\n  color: #ccf2fd;\n  background: #2f5d6d;\n  border-radius: 5px;\n  border: none;\n  &:enabled {\n    color: #ccf2fd;\n  }\n  &:hover {\n    background: #296e79 !important;\n    color: #fefefe;\n  }\n  &:disabled {\n    background: #5c666f;\n    color: #202932;\n  }\n}\n.debug-logs {\n  background: #1e2930;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
